import getLocale from './getLocale';

export default function PoundFormat(num: number, toTwoDecimalPlaces = false) {
    let number = num;
    if (typeof num !== 'number') {
        number = Number(number);
    }
    if (Number.isNaN(number)) {
        number = 0;
    }

    return new Intl.NumberFormat(getLocale(), {
        style: 'currency',
        currency: 'GBP',
        maximumFractionDigits: 2,
        minimumFractionDigits: toTwoDecimalPlaces ? 2 : 0,
    }).format(number);
}
